import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Button } from '@/shared/ui';

export function NotFoundPage() {
  const { t } = useTranslation('shell');
  return (
    <main
      id="main"
      data-page="errors/not-found"
      className="mx-auto flex min-h-dvh max-w-lg flex-col items-center justify-center gap-4 overflow-y-auto p-8 text-center"
    >
      <p className="text-xs font-semibold uppercase tracking-wide text-primary">404</p>
      <h1 className="text-2xl font-semibold text-fg">{t('errors.notFoundTitle')}</h1>
      <p className="text-sm text-fg-muted">{t('errors.notFoundBody')}</p>
      <Button asChild variant="secondary">
        <Link to="/home">{t('errors.backHome')}</Link>
      </Button>
    </main>
  );
}
